import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  searchItemWrap: FelaCSS;
  searchItem: FelaCSS;
}

const styles = (): IStyles => ({
  searchItemWrap: {
    marginBottom: '9px',
    wordBreak: 'break-word',

    maxWidthTabletSm: {
      marginBottom: '16px',
    },
  },

  searchItem: {
    fontDefaultSemiBold: 16,
    lineHeight: '24px',
    color: colors.space,

    maxWidthTabletSm: {
      fontDefault: 14,
      lineHeight: '17px',
    },
  },
});

export default styles;
